import pluralize from "pluralize";
import React from "react";
import { useMediaQuery } from "../../../hooks";
import { Spacer } from "../../spacer";
import styles from "./portal_switch.module.css";

export enum PortalSwitchValue {
  Memberships = "membership",
  MultiPasses = "multipass",
}

interface PortalSwitchProps {
  value: PortalSwitchValue;
  onChange: (value: PortalSwitchValue) => void;
  partner: string;
  showSwitch?: boolean;
  subscriptionCount?: number;
}

export function PortalSwitch({
  value,
  onChange,
  partner,
  showSwitch,
  subscriptionCount,
}: PortalSwitchProps) {
  const { device } = useMediaQuery();

  const handleClickSwitch = () => {
    if (value === PortalSwitchValue.Memberships) {
      onChange(PortalSwitchValue.MultiPasses);
    } else if (value === PortalSwitchValue.MultiPasses) {
      onChange(PortalSwitchValue.Memberships);
    }
  };

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.title}>
          {value === PortalSwitchValue.MultiPasses
            ? "Multi Pass"
            : "Membership"}{" "}
          Portal
        </div>
        {showSwitch && (
          <div
            className={styles.switchComponentWrapper}
            onClick={handleClickSwitch}
          >
            <div className={styles.switchComponent}>
              <div
                className={`${styles.switchCell} ${
                  value === PortalSwitchValue.Memberships && styles.selected
                }`}
              >
                Membership
              </div>
              <div
                className={`${styles.switchCell} ${
                  value === PortalSwitchValue.MultiPasses && styles.selected
                }`}
              >
                Multi Passes
              </div>
              <div
                className={`${styles.backgroundSwitch} ${
                  value === PortalSwitchValue.MultiPasses &&
                  styles.switchToMultiPass
                }`}
              ></div>
            </div>
          </div>
        )}
      </div>
      <Spacer size={device === "mobile" ? 16 : 20} />
      <div>
        Your{" "}
        {value === PortalSwitchValue.MultiPasses
          ? "multi passes"
          : pluralize("membership", subscriptionCount)}{" "}
        at {partner}
      </div>
    </div>
  );
}
